import styled from 'styled-components';

import { Color } from '../../enums';
import { StyledComponent } from '../../interfaces';

import { ContainerProps } from './badge.types';

export const Container: StyledComponent<'div', ContainerProps> = styled.div<ContainerProps>`
  padding: 4px;
  background-color: ${({ $background }: ContainerProps): Color | string => $background};
  color: ${({ $color }: ContainerProps): Color => $color};
  ${({ $border }: ContainerProps): string => $border ? `border: 1px solid ${$border};` : ''}
  display: flex;
  align-items: center;
  width: fit-content;
  border-radius: 4px;
  white-space: nowrap;
`;

export const CloseButton: StyledComponent<'button'> = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const Label: StyledComponent<'div'> = styled.div`
  padding: 0 4px;
  font-size: 12px;
  line-height: 16px;
`;
